
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */
.agenda__container,
.card-container,
.cards-container,
.cards-with-icon,
.cards-with-image,
.carousel-content,
.columns-container,
.columns-layout,
.content-download,
.crosslink-cards,
.csf-hero__wrapper,
.customer-story-hero,
.editorial-story-grid,
.editorial-wrap__section,
.email-capture,
.feature-announcement,
.feature-grid__background,
.feature-spotlight,
.feature-spotlight-vertical,
.feature-tab-container,
.gated-content,
.greenhouse-listings,
.heading-block,
.hero-wrapper,
.legal-wrapper,
.logo-party,
.multifeature-spotlight,
.platform__wrapper,
.rich-text-wrapper,
.roi-calculator-container,
.solution-cards,
.statistics,
.testimonial,
.testimonial-mini,
.testimonial-text-only,
.thank-you-page-hero-container,
.whats-included {
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
  margin-top: 0;
  margin-bottom: 0;

  @include media-query(tablet) {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  @include media-query(laptop) {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  @include media-query(desktop) {
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;
  }

  @include media-query(desktopLg) {
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;
  }
}
`